import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import LineImg2 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_2.png'
import LineImg3 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_3.png'
import LeftArrow from '../../../Assets/images/DFL/landing-page-img/left-arrow.png'
import RightArrow from '../../../Assets/images/DFL/landing-page-img/right-arrow.png'
import Halo_ring from '../../../Assets/images/DFL/eng-ring-shap/halo.webp'
import multirow_ring from '../../../Assets/images/DFL/eng-ring-shap/multirow.webp'
import bypass_ring from '../../../Assets/images/DFL/eng-ring-shap/bypass.webp'
import side_stone_ring from '../../../Assets/images/DFL/eng-ring-shap/sidestone.webp'
import Solitaire_ring from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/solitaire_ring.webp'
import Three_stone_ring from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/three_stone_ring.webp'
import Slider from 'react-slick'
import { NavLink, useHistory } from 'react-router-dom'
const RingShopByStyle = () => {
    const history = useHistory

    const ringShopByStyle = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img src={LeftArrow} />,
        nextArrow: <img src={RightArrow} />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const ringShap = [
        {
            shapImage: Halo_ring,
            shapName: "Halo",
            shapText: "Many tiny diamonds surround the center stone, giving extra sparkle to these stunning rings.",
            url: "/ringsettings/Halo"
        },
        {
            shapImage: Solitaire_ring,
            shapName: "Solitaire",
            shapText: "A classic, timeless choice, made up of a single stone and a plain setting, simple and elegant in appearance.",
            url: "/ringsettings/Solitaire"
        },
        {
            shapImage: Three_stone_ring,
            shapName: "Three Stone",
            shapText: "2 side diamonds accentuate the size and brilliance of the center stone, creating a stunning wow effect.",
            url: "/ringsettings/Three stone"
        },
        // {
        //     shapImage: Single_row_ring,
        //     shapName: "Single Row",
        //     shapText: "Side diamonds are carefully embedded into the single row of this sturdy setting..",
        //     url: "/ringsettings/Channel Set"
        // },
        // {
        //     shapImage: Trellis_ring,
        //     shapName: "Trellis",
        //     shapText: "It is a type of prong setting featuring prongs that interweave to securely hold the center diamond",
        //     url: "/ringsettings/Halo"
        // },
        // {
        //     shapImage: vintage_ring,
        //     shapName: "Vintage",
        //     shapText: "Ideal for the true romantic, these antique-style rings bring back memories of days gone by.",
        //     url: "/ringsettings/Halo"
        // },
        {
            shapImage: multirow_ring,
            shapName: "Multirow",
            shapText: "Two or more dimond rows across the center diamond is  there that looks quite stylish.",
            url: "/ringsettings/Multirow"
        },
        {
            shapImage: bypass_ring,
            shapName: "Bypass",
            shapText: "The diamond is held in place by the physical force of this bold setting, perfect for the modern woman.",
            url: "/ringsettings/Bypass"
        },
        // {
        //     shapImage: pave_ring,
        //     shapName: "Pave",
        //     shapText: "Small diamonds lace the band, giving the appearance of a luminous, solid diamond surface.",
        //     url: "/ringsettings/Pave"
        // },
        {
            shapImage: side_stone_ring,
            shapName: "Side Stone",
            shapText: "Side diamonds bring out the brilliance of the center diamond, creating a true 'statement piece'.",
            url: "/ringsettings/Side stone"
        },

    ]


    return (
        <div className='dfl_eng_Shop_ring_by_style_section'>
            <Container className='dfl_custome_container_staticpage'>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div>
                            <div class="title-box2 text-center border-title mb-0">
                                {/* <img src={LineImg2} alt="line_2" /> */}
                                <h2 class="title24 title-box2 dark">Shop By Style</h2>
                                {/* <img src={LineImg3} alt="line_3" /> */}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className='dfld_shap_slider'>
                            <Slider {...ringShopByStyle} className="dfld_explore_diamond_shap_slider">
                                {ringShap.map((val) => (
                                    <NavLink className='dfld_img_shap_box_outer' to={val.url}>
                                        <div className='dfld_img_shap_box_inner dfl_eng_ring_img'>
                                            <Image src={val.shapImage} alt={val.shapName}/>
                                            <h4>{val.shapName}</h4>
                                            <p>{val.shapText}</p>
                                        </div>
                                    </NavLink>

                                ))}
                            </Slider>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default RingShopByStyle